import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartSolid } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as R from 'ramda';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import { withBorder } from '../../../reactutils/withBorder';
import { withNavLocation } from '../../../reactutils/withNavLocation';
import { withTitle } from '../../../reactutils/withTitle';
import { UserSong } from '../../../services/playlist';
import { DateTime } from '../../DateTime';
import { AlbumImage } from '../../Playlist/AlbumImage';
import { SongAudioPlayer } from '../../Playlist/SongAudioPlayer';
import { usePathSegment } from '../../SysAdminApp/CacheStatisticsComponent';
import { userViewLoadPlaylist } from '../actions';
import { userViewPlaylistProfileSelector, userViewPlaylistSelector, userViewUserNameSelector } from '../selectors';
import { UserViewMenu } from '../UserViewMenu';

const UserViewPlaylist: React.FC<{}> = () => {
    const user = useSelector(userViewPlaylistProfileSelector);
    const userSongs = useSelector(userViewPlaylistSelector);

    const [userId] = usePathSegment(4);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (userId) {
            dispatch(userViewLoadPlaylist(userId));
        }
    }, [dispatch, userId]);

    const renderVote = (songId: string, vote: number) => {
        return [...Array(5).keys()].map((i) =>
            i < vote ? (
                <FontAwesomeIcon key={i} className="me-1" icon={faHeartSolid} />
            ) : (
                <FontAwesomeIcon key={i} className="me-1" icon={faHeartRegular} />
            )
        );
    };

    const renderUserSong = (us: UserSong, index: number) => {
        return (
            <tr key={us.id} className="border-bottom">
                <td>{index + 1}</td>
                <td className="">
                    <AlbumImage imageId={us.albumImageId} />
                </td>
                <td>
                    <div>
                        <strong>
                            {us.songArtist} &mdash; "{us.songName}"
                        </strong>
                    </div>
                    <div>{us.albumName}</div>
                    <div>
                        <SongAudioPlayer songAudioUrl={us.songAudioUrl} />
                    </div>
                    {us.lastPlayed && (
                        <div>
                            <small>
                                zuletzt&nbsp;gespielt:&nbsp;
                                <DateTime date={us.lastPlayed} />
                            </small>
                        </div>
                    )}
                </td>
                <td>{renderVote(us.songId, us.vote)}</td>
            </tr>
        );
    };

    return (
        <div className="mt-3">
            <UserViewMenu activeSubMenu="playlist" />
            {user && !user.playlistDataPublic && (
                <Alert className="mt-3">Der Nutzer hat seine Lieblingsmusik nicht freigegeben.</Alert>
            )}
            {user && user.playlistDataPublic && userSongs.length === 0 && (
                <Alert className="mt-3">Der Nutzer hat noch keine Lieblingsmusik ausgewählt.</Alert>
            )}
            <table className="table table-borderless">
                <tbody>
                    {user && user.playlistDataPublic && userSongs.map((us, index) => renderUserSong(us, index))}
                </tbody>
            </table>
        </div>
    );
};

export const UserViewPlaylistScreen = R.compose(
    withBorder(),
    withTitle('Hörerprofil', userViewUserNameSelector),
    withNavLocation('profile')
)(UserViewPlaylist);
